const CHUNK_LOAD_KEYWORDS = [
  'Failed to load chunk',
  'Loading chunk',
  'Loading CSS chunk',
  'Failed to fetch dynamically imported module',
] as const

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) return false
  return (
    error.name === 'ChunkLoadError' ||
    CHUNK_LOAD_KEYWORDS.some(keyword => error.message.includes(keyword))
  )
}

/** Both React boundaries share a persistent guard against reload loops. */
export function reloadAfterChunkError(error: unknown): boolean {
  if (!isChunkLoadError(error) || typeof window === 'undefined') return false
  try {
    const key = 'chunk-reload-ts'
    const last = window.sessionStorage.getItem(key)
    if (last && Date.now() - Number(last) <= 30_000) return false
    // Persist before navigating; unavailable storage must fail closed.
    window.sessionStorage.setItem(key, String(Date.now()))
    window.location.reload()
    return true
  } catch {
    return false
  }
}
